import { Component, OnInit, Input, Output, EventEmitter, OnChanges, signal, computed } from '@angular/core';
import { IBaseOption } from '../../models/base.model';
import { AcessoCidadaoService } from '../../services/acesso-cidadao.service';
import { Enums } from '../../shared/enums';
import { Utils } from '../../shared/utils';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { FlowObjectType } from '../../models/flow-object.model';
import { IMPORTS } from './_imports';

@Component({
    selector: 'papel-selector',
    templateUrl: './papel-selector.component.html',
    styleUrl: './papel-selector.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class PapelSelectorComponent implements OnInit, OnChanges {
    // #region [Type props]
    FlowObjectType = FlowObjectType;
    // #endregion

    // #region [signals]
    $signerId = signal(null as string);
    $papeis = signal(null as any[]);
    $flowObjectType = signal(FlowObjectType.StartForm);
    $isReadOnly = signal(false);
    $papelOptions = signal([] as IBaseOption[]);
    // #endregion

    // #region [computeds]
    $currentUser = computed(() => this.authService.$user());
    // #endregion

    // #region [Input/Output]
    @Input() _signerId: string;
    @Input() _papeis: any[]; /* pode ser Papel[] ou AgentePublicoPapel[] */
    @Input() _flowObjectType: FlowObjectType = FlowObjectType.StartForm;
    @Input() _isReadOnly: boolean;
    @Output() _signerIdChange = new EventEmitter<string>();
    // #endregion

    constructor(
        private toastr: ToastrService,
        private authService: AuthService,
        private acessoCidadaoService: AcessoCidadaoService
    ) { }

    async ngOnInit() {
        if (this.$isReadOnly()) {
            // caso a Task já tenha sido executada
            const response_Papel = await this.acessoCidadaoService.getPapel(this.$signerId());

            if (!response_Papel.isSuccess) {
                this.toastr.error(response_Papel.message.description, Enums.Messages.Error, Utils.getToastrErrorOptions());
                return;
            }

            this.$papelOptions.set([{
                value: this.$signerId(),
                description: '{0} - {1} - {2} - {3}'
                    .replace('{0}', response_Papel.data.nome)
                    .replace(' - {1}',
                        Utils.isNullOrEmpty(response_Papel.data.lotacao?.nomeCurto)
                        || Utils.isStringEqual(response_Papel.data.lotacao?.nomeCurto, Enums.Messages.DefaultEmptyValue)
                            ? ''
                            : ` - ${response_Papel.data.lotacao?.nomeCurto}`
                    )
                    .replace(' - {2}',
                        Utils.isNullOrEmpty(response_Papel.data.lotacao?.organizacao?.sigla)
                        || Utils.isStringEqual(response_Papel.data.lotacao?.organizacao?.sigla, Enums.Messages.DefaultEmptyValue)
                            ? ''
                            : ` - ${response_Papel.data.lotacao?.organizacao?.sigla}`
                    )
                    .replace(' - {3}',
                        Utils.isNullOrEmpty(response_Papel.data.lotacao?.organizacao?.organizacaoPai?.sigla)
                        || Utils.isStringEqual(response_Papel.data.lotacao?.organizacao?.organizacaoPai?.sigla, Enums.Messages.DefaultEmptyValue)
                            ? ''
                            : ` - ${response_Papel.data.lotacao?.organizacao?.organizacaoPai?.sigla}`
                    )
            }]);
        } else {
            // caso a Task ainda não tenha sido executada
            this.$papelOptions.set(Array.from(this.$papeis(), item => {
                if (item.lotacao != null) {
                    return {
                        value: item.guid,
                        description: '{0} - {1} - {2} - {3}'
                            .replace('{0}', item.nome)
                            .replace(' - {1}',
                                Utils.isNullOrEmpty(item.lotacao?.nomeCurto)
                                || Utils.isStringEqual(item.lotacao?.nomeCurto, Enums.Messages.DefaultEmptyValue)
                                    ? ''
                                    : ` - ${item.lotacao?.nomeCurto}`
                            )
                            .replace(' - {2}',
                                Utils.isNullOrEmpty(item.lotacao?.organizacao?.sigla)
                                || Utils.isStringEqual(item.lotacao?.organizacao?.sigla, Enums.Messages.DefaultEmptyValue)
                                    ? ''
                                    : ` - ${item.lotacao?.organizacao?.sigla}`
                            )
                            .replace(' - {3}',
                                Utils.isNullOrEmpty(item.lotacao?.organizacao?.organizacaoPai?.sigla)
                                || Utils.isStringEqual(item.lotacao?.organizacao?.organizacaoPai?.sigla, Enums.Messages.DefaultEmptyValue)
                                    ? ''
                                    : ` - ${item.lotacao?.organizacao?.organizacaoPai?.sigla}`
                            )
                    };
                } else {
                    return {
                        value: item.id,
                        description: '{0} - {1} - {2}'
                            .replace('{0}', item.nome)
                            .replace(' - {1}',
                                Utils.isNullOrEmpty(item.siglaUnidadePapel)
                                || Utils.isStringEqual(item.siglaUnidadePapel, Enums.Messages.DefaultEmptyValue)
                                    ? ''
                                    : ` - ${item.siglaUnidadePapel}`
                            )
                            .replace(' - {2}',
                                Utils.isNullOrEmpty(item.siglaOrganizacaoPapel)
                                || Utils.isStringEqual(item.siglaOrganizacaoPapel, Enums.Messages.DefaultEmptyValue)
                                    ? ''
                                    : ` - ${item.siglaOrganizacaoPapel}`
                            )
                    };
                }
            }));

            this.$signerId.set(this.$papelOptions().length > 0 ? this.$papelOptions()[0].value : this.$currentUser().id);
            this.onChange();
        }
    }

    ngOnChanges() {
        this.$signerId.set(this._signerId);
        this.$papeis.set(this._papeis);
        this.$flowObjectType.set(this._flowObjectType);
        this.$isReadOnly.set(this._isReadOnly);
    }

    onChange(event?) {
        if (event != null) {
            this.$signerId.set(event);
        }

        this._signerIdChange.emit(this.$signerId());
    }

    // #region [===== private methods =====]
    // #endregion
}
